import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const requireContext = require.context("./modules", false, /.*\.js$/);
const modules = requireContext
  .keys()
  .map((file) => [file.replace(/(^.\/)|(\.js$)/g, ""), requireContext(file)])
  .reduce((modules, [name, module]) => {
    if (module.namespaced === undefined) {
      module.namespaced = true;
    }
    return { ...modules, [name]: module };
  }, {});

export default new Vuex.Store({
  strict: false,
  modules,
  plugins: [
    createPersistedState({
      // Указываем, что нужно сохранять ТОЛЬКО ТОКЕН
      paths: [
        "IndicationsHistory",
        "PaymentHistory",
        "Auth.authToken", // <--- ВОТ ЭТА СТРОКА КЛЮЧЕВАЯ
        "Auth.userCredentials",
      ],
    }),
  ],
});
